module.exports = __webpack_public_path__ + "static/img/asian.87e698f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/asian.jpeg
// module id = UTtB
// module chunks = 1